export const initWishlists = () => {
    $(".js-wishlist-new-trigger").on("click", function (event) {
        var $this = $(this),
            $content = $this.parents(".js-wishlist-popup-content"),
            $form = $content.find(".js-wishlist-new");

        event.preventDefault();

        $this.hide();
        $form.slideDown(200);
        $form.find(".js-wishlist-popup-new-input").focus();
    });

    $(".js-wishlist-popup-list").each(function () {
        $(this)
            .find(".js-wishlist-popup-checkbox")
            .on("change", function () {
                var $this = $(this),
                    wishlistId = $this.val(),
                    addUrl = $this.data("add-url"),
                    deleteUrl = $this.data("delete-url"),
                    productId = $this.data("product-id"),
                    isChecked = $this.is(":checked"),
                    url = isChecked ? addUrl : deleteUrl;

                $this.prop("disabled", true);
                $this.addClass("is-loading");

                $.post(
                    url,
                    { product_id: productId, customer_wishlist_id: wishlistId },
                    function (data) {
                        Eshop.alert(data.message, { type: data.status ? "success" : "error" });
                        $this.prop("disabled", false);
                        $this.removeClass("is-loading");
                    },
                    "json"
                );
            });
    });

    $(".js-form-wishlist-create").each(function () {
        $(this).validate({
            submitHandler: function (form) {
                $(form)
                    .find('button[type="submit"]')
                    .prop("disabled", true)
                    .prop("data-state", "is-loading");

                Form.ajaxPost(
                    form,
                    function (data) {
                        if (data.status) {
                            var $popup = $(form).parents(".js-wishlist-popup"),
                                $list = $popup.find(".js-wishlist-popup-list"),
                                $input = $(form).find(".js-wishlist-popup-new-input"),
                                $form = $popup.find(".js-wishlist-new"),
                                $link = $popup.find(".js-wishlist-new-trigger"),
                                wishlist_name = $input.val();

                            $link.show();
                            $form.slideUp(200);

                            $(".js-wishlist-popup-list").each(function () {
                                var $item = $(this).find(".js-wishlist-popup-item").eq(0),
                                    inputId =
                                        "wish_" +
                                        data.wishlist_id +
                                        "_" +
                                        $(this).data("product-id") +
                                        "_" +
                                        Math.floor(Math.random() * 100);

                                if ($item.hasClass("is-empty")) {
                                    $item.removeClass("is-empty");

                                    $(this).parents(".js-wishlist-popup").removeClass("is-empty");
                                } else {
                                    $item = $item.clone();
                                }

                                console.log($item);
                                console.log(inputId);

                                $input.val("");
                                $(form)
                                    .find('button[type="submit"]')
                                    .prop("disabled", false)
                                    .prop("data-state", false);

                                $item
                                    .find(".js-wishlist-popup-checkbox")
                                    .prop("disabled", false)
                                    .prop("checked", $(this).data("product-id") == data.product.id)
                                    .attr("id", inputId)
                                    .val(data.wishlist_id);

                                $item.find("label").html(wishlist_name).attr("for", inputId);

                                $item.prependTo($(this).find("form").first());
                            });

                            $list.animate(
                                {
                                    scrollTop: 0,
                                },
                                200
                            );
                        }

                        Eshop.alert(data.message, { type: data.status ? "success" : "error" });
                    },
                    "json"
                );
            },
        });
    });

    $(".js-wishlist-show-list").on("click", function (event) {
        var $this = $(this),
            $content = $this.parents(".js-wishlist-popup-content"),
            $list = $content.find(".js-wishlist-popup-list");

        event.preventDefault();

        $this.hide();
        $list.slideDown(200);
    });

    $(".js-wishlist-taste-change").on("click", function (event) {
        const $button = $(this);
        const customerWishlistProductId = $button.attr("data-wishlist-product-id");
        const isTasted = $button.attr("data-tasted") == 1 ? 0 : 1;

        $.post(
            "/wishlist-change-tasting",
            {
                customer_wishlist_product_id: customerWishlistProductId,
                custom_tasted: isTasted,
            },
            function (data) {
                $button.attr("data-tasted", isTasted);
                $button.parents(".js-thumb").find(".js-taste-ribbon").attr("data-tasted", isTasted);
                $button.parents(".js-thumb").find(".js-wishlist-popup-content")[0].handleToggle(0);
                Eshop.alert(data.msg, { type: data.status ? "success" : "error" });
            },
            "json"
        );
    });

    document.querySelectorAll(".js-wishlist-popup-content").forEach(function (rToggle) {
        rToggle.addEventListener("rToggle.afterOpen", function (event) {
            const thumbEl = rToggle.closest(".js-thumb");

            if (thumbEl) {
                thumbEl.classList.add("is-active");
            }
        });

        rToggle.addEventListener("rToggle.afterClose", function (event) {
            const thumbEl = rToggle.closest(".js-thumb");

            if (thumbEl) {
                thumbEl.classList.remove("is-active");
            }
        });
    });
};

$(function () {
    initWishlists();
});
